import { render } from "./PasswordForceCheck.vue?vue&type=template&id=7a022366&ts=true"
import script from "./PasswordForceCheck.vue?vue&type=script&lang=ts"
export * from "./PasswordForceCheck.vue?vue&type=script&lang=ts"

import exportComponent from "/home/helder/SDD_2/Projetos/goldylocks-central-ui-v2/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__